import * as Sentry from '@sentry/react';
import { version as appVersion } from 'client/package.json';
import ClientConfig from 'client/config';

const sentryReplayConfig = {
  maskAllInputs: false,
  maskAllText: false,
  blockAllMedia: false,
};

const sentryIgnoreErrors = [
  /*
    ResizeObserver loop errors do not crash the application, and can be safely
    ignored according to the spec author: https://stackoverflow.com/a/50387233/942635
   */
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'Network Error',
  'NetworkError when attempting to fetch resource',
  /*
    ow-5807:
    https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/17
   */
  'Non-Error promise rejection captured',
];

const shouldCreateSpanForRequest = (url: string): boolean => {
  /**
   * Exclude Zendesk requests from Sentry tracing because the Zendesk Web Widget
   * performs many internal network calls when opening.
   *
   * MR: https://gitlab.oliasoft.com/oliasoft/welldesign/-/merge_requests/15858
   */
  return !url.includes('zdassets.com') && !url.includes('zendesk.com');
};

const sentryConfig: Sentry.BrowserOptions = {
  dsn: "https://13dd242dd31737b6671ea72e75437c57@o324733.ingest.us.sentry.io/4511886101774336",
  release: `atlas-${appVersion}`,
  environment: ClientConfig.config.sentryEnvironment,

  ignoreErrors: sentryIgnoreErrors,

  tracesSampleRate: 0.5,
  tracePropagationTargets: [/^https:\/\/(.*\.)?oliasoft\.com/],

  // Do not record normal user sessions, only sessions where an error occurs.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  integrations: [
    Sentry.browserTracingIntegration({
      shouldCreateSpanForRequest,
    }),
    Sentry.replayIntegration(sentryReplayConfig),
  ],
};

if (ClientConfig.config.enableSentry) {
  Sentry.init(sentryConfig);
}
